import { FeatureFlagKey } from "@salestrak/feature-flags";
import { useFeatureFlags } from "#app/hooks/use-feature-flags";

/**
 * Whether the `AUTOMATIONS` flag is enabled for the active workspace.
 *
 * Gates the workspace-selector Automations entry (alongside the
 * `automations.manage` permission). Returns `false` until flags have
 * resolved, so the gated UI stays hidden during the initial fetch.
 */
export function useAutomationsEnabled(): boolean {
  const { ready, hasFlag } = useFeatureFlags();
  return ready && hasFlag(FeatureFlagKey.AUTOMATIONS);
}
